import axios from 'axios'
import { API_URL } from 'services/config'
import ComunicationsDto from 'dto/ComunicationsDto'
import ComunicationDto from 'dto/ComunicationDto'
import Paginator from 'models/Paginator'

class ComunicationsService {
    listComunications = (params) =>
        axios
            .get(`${API_URL}/communications`, { params })
            .then(({ data: { data, pagination } }) => {
                return {
                    comunications: ComunicationsDto.fromJson(data),
                    paginator: Paginator.fromJson(pagination),
                }
            })

    getComunication = (id, params) =>
        axios
            .get(`${API_URL}/communications/${id}`, { params })
            .then(({ data: { data } }) => ComunicationDto.fromJson(data))

    getComunicationDocumentLink = (comunicationId, documentId) =>
        axios.get(`${API_URL}/communications/${comunicationId}/files/${documentId}/download`).then(
            ({
                data: {
                    data: { url },
                },
            }) => url
        )

    getCarouselImages = () =>
        axios
            .get(`${API_URL}/commons/carousel`)
            .then(({ data: { data } }) => data?.web)

}

export default ComunicationsService
